import { useStyletron } from 'styletron-react'
import * as styles from '../Styles'
const TableActions = props => {
  const [css] = useStyletron()
  return <div className={css(styles.actions)}>{props.children}</div>
}
export default TableActions
